import { getEnv, Instance, types } from "mobx-state-tree";
import { ForeContext } from "../../context";

export const ContextStore = types.model("ContextStore").views((self) => {
  const views = {
    get foreContext(): ForeContext {
      return getEnv(self).foreContext;
    }
  };

  return views;
});

export type IContextStore = Instance<typeof ContextStore>;
